export default {
    name: "category-discover",
    template: '#categories-discover',
    data() {
        return {}
    },

    props: {
        categories: Array,
        selectedCategories: Array,
        placeholder: String
    },
}